import React, { useEffect, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { m } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router';
import Image from '../../components/Image';
import Iconify from '../../components/Iconify';
import useAuth from '../../hooks/useAuth';
import { useDispatch } from '../../redux/store';
import { openLoginSignup } from '../../redux/slices/authPages';
import conObj from '../../utils/connection-assistant';

const SpinWheelButton = ({ sx }) => {
  const [isOpen, setIsOpen] = useState(true);

  const [isExist, setIsExist] = useState(false);

  const { isAuthenticated } = useAuth();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const location = useLocation();

  const handleClick = () =>
    isAuthenticated ? navigate('/spin') : dispatch(openLoginSignup({ open: true, isLogin: true }));

  const getSpinWheelPromo = async () => {
    try {
      const response = await conObj.post(`promotion.json`, {
        promotion_type: 'spin_wheel_manual',
      });

      setIsExist(!!response.data.data?.data?.length);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSpinWheelPromo();
  }, []);

  //   if (!isOpen || location.pathname !== '/') return <></>;
  if (!isOpen || location.pathname !== '/home' || !isExist) return <></>;

  return (
    <Box
      sx={{
        width: { xs: '70px', sm: '70px', md: '80px' },
        display: 'flex',
        alignItems: 'start',
        ...sx,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: 'auto',
        }}
      >
        <Box
          sx={{ cursor: 'pointer', width: '100%' }}
          component={m.div}
          animate={{ rotate: [0, 720, 1440, 2160, 2880, 3240, 3600] }}
          transition={{
            duration: 10,
            ease: [0.5, 1, 0.5, 1],
            times: [0, 0.2, 0.4, 0.6, 0.8, 0.9, 1],
            repeat: Infinity,
            repeatType: 'loop',
          }}
        >
          <Image src={require('../../assets/spin/sample-wheel.webp')} />
        </Box>

        <Image
          onClick={handleClick}
          src={require('../../assets/spin/spin-button.gif')}
          sx={{ width: '50%', position: 'absolute', zIndex: 6, cursor: 'pointer' }}
        />

        <Image
          alt="Lucky Wheel Border"
          onClick={handleClick}
          src={require('../../assets/spin/outer-wheel.webp')}
          sx={{
            position: 'absolute',
            width: '100%',
            // top: '10%',
            zIndex: 5,
            transform: 'scale(1.14)',
            cursor: 'pointer',
          }}
        />
      </Box>

      <IconButton onClick={() => setIsOpen(false)} sx={{ p: 0, m: 0, marginTop: '-20px', marginLeft: '-10px' }}>
        <Iconify icon="carbon:close-filled" sx={{ color: '#F0C335', fontSize: '20px' }} />
      </IconButton>
    </Box>
  );
};

export default SpinWheelButton;
